<div fxLayout="column">
  <lin-form-label>
    @if (notesTitle) {
    <span>{{ notesTitle }}:</span>
    } @else {
    <span>{{ 'FIELDS.NOTES_HISTORY' | translate }} {{ noteText || '' }}:</span>
    } @if (isClient) {
    <a (click)="addNote()" data-testid="btn-add-note">{{ 'FIELDS.ADD_NEW_NOTE' | translate }}</a>
    }
  </lin-form-label>
  <ul class="note-list" [style.height.px]="height">
    @for (item of notesHistory; track item.id) {
    <li class="note-list__item">
      <div class="note-list__item-header">
        <strong class="note-list__item-name">{{ item.createdBy.fullName }}</strong>
        <span class="note-list__item">{{ item.createdAt | dayjsDateTime }}</span>
      </div>
      @if (item.arrayNotes) { @for (note of item.note; track $index) {
      <div>{{ note }}</div>
      } } @else {
      <div>{{ item.note }}</div>
      } @if (item.createdBy.email === currentUserEmail) {
      <span class="cross-mark" (click)="onDeleteNote(item.id)" data-testid="btn-delete-note"></span>
      }
    </li>
    }
  </ul>
</div>
